<script>
  import IntlMessageFormat from "intl-messageformat";
  import { createEventDispatcher, onDestroy, onMount } from "svelte";
  import HtmlContent from "@components/HtmlContent";
  import { _, locale } from "@services/i18n";

  const dispatch = createEventDispatcher();
  const listeners = [];
  let child;
  let methods = [];

  $: ({content, default: defaultTranslation, key, ...values} = $$props);

  $: if (content) {
    const contentNotYetInterpolated =
      Object.keys(values).some((valueKey) => content.includes(`{${valueKey}}`));
    if (contentNotYetInterpolated) {
      try {
        const formatter = new IntlMessageFormat(
          content,
          $locale,
          {},
          { ignoreTag: true }
        );
        content = formatter.format(values);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    }
  } else if (key && defaultTranslation) {
    content = $_(key, {default: defaultTranslation, values});
  }

  $: if (content.includes("data-on")) {
    const regex = /data-on="([^|:"]+)[|:]?[^:"]*:?([^"]*)"/g;
    const matches = content.match(regex);
    if (matches) {
      methods = matches.map(match => match.replace(
        regex,
        (_content, type, method) => {
          if (method) {
            return method;
          }
          return type;
        }));
    }
  }

  onMount(() => {
    methods.forEach(method => {
      // eslint-disable-next-line max-nested-callbacks
      listeners.push(child.$on(method, () => {
        dispatch(method);
      }));
    });
  });

  onDestroy(() => {
    listeners.forEach(listener => listener());
  });
</script>

<HtmlContent bind:this={child} {content} />
